import type { OnboardingStatus } from '../types/onboarding';
import { about } from '../pages/Connection/components/AboutCompany';
import { appInfoInst } from '../pages/Connection/components/AppInfo';
import { companySignatoryInst } from '../pages/Connection/components/CompanySignatory';
import { contactPersonInst } from '../pages/Connection/components/ContactPerson';
import { corparateDoc } from '../pages/Connection/components/CorporateDocument';
import { director as directorInst } from '../pages/Connection/components/Director';
import isCompleteAllSteps from '../pages/Connection/helper';
import userStore from 'store/User';

export type UserStatus = 'new' | 'in-review' | 'active' | 'rejected' | string;

export interface UserStatusCheck {
  status: UserStatus | null | undefined;
  isNew: boolean;
  isInReview: boolean;
  isActive: boolean;
  isRejected: boolean;
  needsOnboarding: boolean;
}

export const getUserStatusInfo = (user: any): UserStatusCheck => {
  const status = user?.company?.status;

  // Проверяем что основные данные загружены
  const isUserDataLoaded = !!user && !!user.company;
  const isLoadingMe = userStore.isLoadingMe;
  const isLoadingOnboarding = userStore.isLoadingOnboarding;

  // Если данные пользователя или онбординга еще загружаются, не показываем онбординг
  if (!isUserDataLoaded || isLoadingMe || isLoadingOnboarding) {
    return {
      status,
      isNew: false,
      isInReview: false,
      isActive: false,
      isRejected: false,
      needsOnboarding: false, // Не показываем пока данные загружаются
    };
  }

  // В первую очередь проверяем onboardingSteps
  // Если null (404 ошибка) - нужен онбординг независимо от статуса
  const hasOnboardingSteps = userStore.onboardingSteps !== null;
  const needsOnboardingBySteps = !hasOnboardingSteps;

  // Если onboardingSteps есть, проверяем по статусу компании
  const needsOnboardingByStatus = ['new', 'in-review'].includes(status);

  return {
    status,
    isNew: status === 'new',
    isInReview: status === 'in-review',
    isActive: status === 'active',
    isRejected: status === 'rejected',
    needsOnboarding: needsOnboardingBySteps || needsOnboardingByStatus,
  };
};

/**
 * Получить детальную информацию о статусе онбординга
 */
// KOMAROV
export function getOnboardingStatus(): OnboardingStatus {
  const isIE = about?.values?.details?.company_form === 'sole-proprietor';
  const onboardingSteps = userStore.onboardingSteps;

  // Проверяем статус по серверным данным (если загружены) ИЛИ локальным флагам
  const isAppInfoCompleted =
    onboardingSteps?.appGameInfo || appInfoInst.isDataSended;
  const isBasicCompanyInfoCompleted =
    onboardingSteps?.basicCompanyInfo || about.isDataSended;
  const isCompanySignatoryCompleted =
    onboardingSteps?.companySignatory || companySignatoryInst.isDataSended;
  const isContactPersonCompleted =
    onboardingSteps?.contactPerson || contactPersonInst.isDataSended;
  const isCorporateDocumentsCompleted =
    onboardingSteps?.corporateDocuments || corparateDoc.isDataSended;
  const isDirectorsCompleted =
    onboardingSteps?.UBOsDirectors || directorInst.isDataSended;

  const isAllCompleted =
    isAppInfoCompleted &&
    isBasicCompanyInfoCompleted &&
    isCompanySignatoryCompleted &&
    isContactPersonCompleted &&
    isDirectorsCompleted &&
    (isIE ? true : isCorporateDocumentsCompleted);

  return {
    isAppInfoCompleted,
    isBasicCompanyInfoCompleted,
    isCompanySignatoryCompleted,
    isContactPersonCompleted,
    isCorporateDocumentsCompleted,
    isDirectorsCompleted,
    isAllCompleted,
    isIE: isIE || false,
  };
}
